(() => {
  if (window.mmProductProStickyBound) return;
  window.mmProductProStickyBound = true;

  let ticking = false;
  const update = () => {
    ticking = false;
    const sticky = document.querySelector('.mm-pro-sticky-inquiry');
    const primary = document.querySelector('[id$="__mm-pro-main"] [data-block-id="contact"] .button');
    const contact = document.querySelector('[id$="__mm-pro-contact"]');
    if (!sticky || !primary) return;
    const passedPrimary = primary.getBoundingClientRect().bottom < 0;
    const contactRect = contact?.getBoundingClientRect();
    const atContact = contactRect && contactRect.top < innerHeight && contactRect.bottom > 0;
    const show = passedPrimary && !atContact && matchMedia('(max-width: 699px)').matches;
    sticky.classList.toggle('is-visible', show);
    sticky.tabIndex = show ? 0 : -1;
  };
  const schedule = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
  document.addEventListener('shopify:section:load', schedule);
})();
